module.exports = __webpack_public_path__ + "static/joint-evaluation-question-e0ba5de8f6cef73d3cbd514046669358.jpg";